import React from 'react';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';
import { OverlayLoader } from 'components';

const useStyles = createUseStyles((theme: Theme) => ({
  pageBg: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    backgroundColor: theme.colors.grayBackground,
    paddingTop: theme.marginBase * 12,
    paddingBottom: theme.marginBase * 12,
    minHeight: '100vh',

    [theme.media.tablet]: {
      paddingTop: 0,
      paddingBottom: 0,
    },
  },
  container: {
    backgroundColor: theme.colors.white,
    boxShadow: theme.boxShadow.base,
    padding: theme.marginBase * 10,
    [theme.media.mobile]: {
      padding: theme.marginBase * 2,
      paddingTop: theme.marginBase * 4,
    },
  },
  logoContainer: {
    marginBottom: theme.marginBase * 7,
    display: 'flex',
    justifyContent: 'center',
  },
  logo: {
    maxHeight: 120,
    maxWidth: 240,
  },
  content: {
    width: '100%',
    maxWidth: theme.maxContentWidth.regular,
  },
  title: {
    ...theme.fonts.h3,
    marginBottom: theme.marginBase * 6,
    textAlign: 'center',
  },
}));

interface Props {
  children: React.ReactNode;
  fetching?: boolean;
  title: string | React.ReactNode;
  logoUrl?: string | null;
}

export const SubscriptionFormBg = (props: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });
  const { fetching, children, title, logoUrl } = props;

  return (
    <div className={classes.pageBg}>
      <div className={classes.container}>
        {fetching && <OverlayLoader fixed />}
        <div className={classes.content}>
          {logoUrl && (
            <div className={classes.logoContainer}>
              <img className={classes.logo} src={logoUrl} alt="logo" />
            </div>
          )}
          <h1 className={classes.title}>{title}</h1>
          {children}
        </div>
      </div>
    </div>
  );
};
